var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import MatchScoresAdapter from './MatchScoresAdapter';
import Score from './Score';
function renderMainScore(score) {
    return (_jsx(Score, { score: score, mainScore: true }, score.get('id')));
}
function renderScore(score) {
    return (_jsx(Score, { score: score }, score.get('id')));
}
function renderAdditionalScores(scores) {
    if (scores.size === 0) {
        return false;
    }
    return (_jsx("span", __assign({ className: "scores" }, { children: scores.map(renderScore) })));
}
var Match = function (props) {
    if (props.match === undefined) {
        return false;
    }
    var matchScores = props.match.get('scores');
    var sportId = props.match.get('sportId');
    var timezone = moment.tz.guess();
    var startDate = moment(props.match.get('startDate')).tz(timezone).format('HH:mm');
    var matchName = props.match.get('name');
    var matchNotice = props.match.get('notice');
    var remark = props.match.get('remark');
    if (matchNotice) {
        matchName = "".concat(matchName, " (").concat(matchNotice, ")");
    }
    if (remark) {
        matchName = "".concat(matchName, " (").concat(remark, ")");
    }
    var mainScore = MatchScoresAdapter.getMainScore(sportId, matchScores, props.scores);
    var additionalScores = MatchScoresAdapter.getAdditionalScores(sportId, matchScores, props.scores);
    return (_jsxs("div", __assign({ className: "line ".concat(props.sportCssName) }, { children: [_jsxs("div", __assign({ className: 'time' }, { children: [_jsxs("strong", { children: [startDate, " "] }), props.leagueName] })), _jsx("div", __assign({ className: 'name' }, { children: matchName })), _jsxs("div", __assign({ className: 'result' }, { children: [mainScore && renderMainScore(mainScore), "\u00A0", additionalScores && additionalScores.length > 0 && renderAdditionalScores(additionalScores)] }))] })));
};
Match.propTypes = {
    match: PropTypes.object.isRequired,
    leagueName: PropTypes.string.isRequired,
    sportCssName: PropTypes.string.isRequired,
    scores: PropTypes.object.isRequired
};
function mapStateToProps(state, props) {
    var id = props.id;
    var section = props.section;
    var match = state.application.getIn([section, 'matches', id]);
    var scores = state.application.getIn([section, 'scores']);
    return {
        match: match,
        scores: scores
    };
}
Match = connect(mapStateToProps)(Match);
export default Match;



// WEBPACK FOOTER //
// ./src/components/info/results/Match.jsx